// extracted by mini-css-extract-plugin
module.exports = {"ButtonGroup":"Footer__ButtonGroup___76mSL","Button":"Footer__Button___xCb0P"};